// src/Store/slices/User.js

import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  user: null,
  accessToken: null,
  pharmacyDetails: null, 
  isLoading: false,
  error: null,
  message: null,
};

// Create slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { accessToken, user, message } = action.payload;
      if (accessToken !== undefined) state.accessToken = accessToken;
      if (user !== undefined) state.user = user;
      if (message !== undefined) state.message = message;
    },
    setPharmacyDetails: (state, action) => {
      state.pharmacyDetails = action.payload; 
    },
    setUserLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setPharmacyDetails, setUserLoading } = userSlice.actions;
export default userSlice.reducer;
